import { ColumnDef } from '@tanstack/react-table';
import { SortableHeader, TruncatedCell } from '@/components';
import { formatTableDate } from '../../utils/formatTableDate';
import { ProcedureDataRecord } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DocumentSource, DocumentType } from '../../viewer';

export const createProceduresColumns = (): ColumnDef<ProcedureDataRecord>[] => [
  {
    accessorKey: 'name',
    header: 'Procedure',
    cell: ({ row }) =>
      row.original.name ? (
        <TruncatedCell text={row.original.name} className="font-medium" />
      ) : (
        'No data available'
      ),
  },
  {
    id: 'dateOfStudy',
    accessorKey: 'date',
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Procedure Date</SortableHeader>
    ),
    cell: ({ row }) => formatTableDate(row.original.date),
  },
  {
    accessorKey: 'providerType',
    header: 'Provider Type',
    cell: ({ row }) => row.original.providerType || 'No data available',
  },
  {
    id: 'sourceType',
    accessorFn: (row) => row.sourceTypes,
    header: 'Sources',
    cell: ({ row }) => {
      const sourceTypes = row.original.sourceTypes ?? [];
      if (sourceTypes.length === 0) return 'No data available';
      return sourceTypes.join(', ');
    },
  },
  {
    id: 'actions',
    enableSorting: false,
    header: '',
    cell: ({ row }) => {
      const firstSourceType = row.original.sourceTypes[0];
      return (
        <div className="flex items-center justify-end">
          <PatientDocumentViewButton
            disabled={!firstSourceType}
            documentKey={{
              source: DocumentSource.MEDICAL_DATA,
              type: DocumentType.PROCEDURES,
              procedureId: row.original.id,
              sourceType: firstSourceType,
              name: row.original.name,
            }}
          />
        </div>
      );
    },
  },
];
